const logoMap = {
  default: {
    menu: require('whitelabel/default/menu.logo.svg'),
    filter: require('whitelabel/default/filter.logo.svg'),
    pageTitle: 'Locate Assurance<sup>®</sup>',
    headerBackgroundColor: '#0F0B72',
    buttonBorderWidth: '1px',
    footerCopyright: 'UTTO Technologies',
  },
  Premier_IE: {
    menu: require('whitelabel/Premier_IE/menu.logo.svg'),
    filter: require('whitelabel/Premier_IE/filter.logo.png'),
    pageTitle: 'Locate Assurance<sup>®</sup>',
    footerTitle: 'Powered by UTTO Locate Assurance',
    headerBackgroundColor: '#002F6C',
    buttonBorderWidth: '3px',
    subdomain: 'lpm',
    footerCopyright: 'UTTO Technologies',
  },
  Chevron: {
    menu: require('whitelabel/Chevron/menu.logo.svg'),
    filter: require('whitelabel/Chevron/filter.logo.svg'),
    pageTitle: 'Locate Assurance<sup>®</sup>',
    headerBackgroundColor: '#0F0B72',
    buttonBorderWidth: '1px',
    footerCopyright: 'UTTO Technologies',
  },
  RadioDetection: {
    menu: require('whitelabel/RadioDetection/menu.logo.png'),
    filter: require('whitelabel/RadioDetection/filter.logo.png'),
    pageTitle: '<span style="color: #efa768;">L</span>ocate <span style="color: #efa768;">P</span>erformance <span style="color: #efa768;">M</span>anagement<sup>™</sup>',
    footerTitle: 'Powered by UTTO Locate Assurance',
    headerBackgroundColor: '#002F6C',
    buttonBorderWidth: '3px',
    subdomain: 'lpm',
    footerCopyright: 'UTTO and Radiodetection Ltd. All rights reserved. UTTO and Locate Assurance are copyright of IPEG Corporation. Radiodetection is a subsidiary of SPX Technologies, Inc. Radiodetection and Locate Performance Management are either trademarks or registered trademarks of Radiodetection in the United States and/or other countries.',
    tabTitle: 'LPM',
    favicon: require('./RadioDetection/favicon-light.ico'),
    faviconLight: require('./RadioDetection/favicon-light.ico'),
    faviconDark: require('./RadioDetection/favicon-dark.ico'),
    footerBackgroundColor: '#f0f0f0',
    footerTextColor: '#000',
    footerTextSize: '10px',
    sideMenuText: 'Powered by UTTO<sup>™</sup>',
  },
  NGrid1: {
    menu: require('whitelabel/NGrid1/menu.logo.svg'),
    filter: require('whitelabel/NGrid1/white.logo.svg'),
    pageTitle: 'Locate Assurance<sup>®</sup>',
    headerBackgroundColor: '#0F0B72',
    buttonBorderWidth: '1px',
    footerCopyright: 'UTTO Technologies',
  },
};

// Check if this is the specific LPM RadioDetection domain or URL parameter override
export const isLpmRadioDetection = () => {
  const { hostname, search } = window.location;
  const urlParams = new URLSearchParams(search);

  // If URL parameter is set, always use LPM branding regardless of domain
  if (urlParams.get('lpm') === '1') {
    return true;
  }

  // If domain is specifically lpm.radiodetection.com or similar, use LPM branding
  if (hostname === 'lpm.radiodetection.com' || hostname === 'lpm-test.radiodetection.com') {
    return true;
  }

  return false;
};

// Helper function to normalize image URLs
const normalizeImageUrl = (image) => {
  if (!image) return image;
  
  if (typeof image === 'string') {
    return image;
  }

  if (typeof image === 'object' && image !== null) {

    if ('default' in image && typeof image.default === 'string') {
      return image.default;
    }

    if (image.src && typeof image.src === 'string') {
      return image.src;
    }
  }
  
  return image;
};

export const getBranding = (org, div) => {
  let branding;
  
  if (isLpmRadioDetection()) {
    branding = logoMap['RadioDetection'];
  } else if (logoMap[org]) {
    branding = logoMap[org];
  } else {
    branding = logoMap.default;
  }

  // Normalize image URLs
  return {
    ...branding,
    menu: normalizeImageUrl(branding.menu),
    filter: normalizeImageUrl(branding.filter),
    favicon: normalizeImageUrl(branding.favicon),
    faviconLight: normalizeImageUrl(branding.faviconLight),
    faviconDark: normalizeImageUrl(branding.faviconDark),
  };
}
